import type { NamespaceSchema } from './types';

// Field paths match apps/api/src/core/sms/settings.ts (interface
// SmsSettings). Per-event audience toggles (eventCreateBooking.admin.enabled
// etc.) are nested booleans — schema renderer handles them via dotted keys.
//
// Twilio account SID, auth token, and From number live in env (TWILIO_*).
//
// A custom SmsSettingsEditor with a test-send button lives in
// routes/Configs.tsx — that's the surface operators normally use; this
// schema is the structured fallback.

export const smsSettings: NamespaceSchema = {
  namespace: 'sms-settings',
  label: 'SMS',
  description: 'Outbound transactional SMS via Twilio. Credentials are env-only; this namespace controls the master toggle and which audiences receive each event.',
  sections: [
    {
      label: 'Master toggle',
      fields: [
        { kind: 'boolean', key: 'enabled', label: 'SMS enabled', default: false, description: 'Off here = no SMS sent regardless of per-event toggles below.' },
      ],
    },
    {
      label: 'Admin contact',
      fields: [
        { kind: 'text', key: 'adminPhone', label: 'Admin phone (E.164)', placeholder: '+212601020304' },
        { kind: 'select', key: 'adminCountry', label: 'Admin country', default: 'MA', options: [
          { value: 'MA', label: 'Morocco (+212)' },
          { value: 'AE', label: 'UAE (+971)' },
          { value: 'GB', label: 'UK (+44)' },
          { value: 'ES', label: 'Spain (+34)' },
          { value: 'US', label: 'US (+1)' },
        ] },
      ],
    },
    {
      label: 'Booking created → confirmed',
      description: 'Who receives the SMS when a booking is paid + confirmed.',
      fields: [
        { kind: 'boolean', key: 'eventCreateBooking.admin.enabled', label: 'Notify admin', default: false },
        { kind: 'boolean', key: 'eventCreateBooking.vendor.enabled', label: 'Notify vendor', default: false },
        { kind: 'boolean', key: 'eventCreateBooking.customer.enabled', label: 'Notify customer', default: false },
      ],
    },
    {
      label: 'Booking updated (cancellation, status change)',
      fields: [
        { kind: 'boolean', key: 'eventUpdateBooking.admin.enabled', label: 'Notify admin', default: false },
        { kind: 'boolean', key: 'eventUpdateBooking.vendor.enabled', label: 'Notify vendor', default: false },
        { kind: 'boolean', key: 'eventUpdateBooking.customer.enabled', label: 'Notify customer', default: false },
      ],
    },
  ],
};
